import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import './css/Header.css';

import { FaCaretDown } from 'react-icons/fa';

import profile from './assets/profile.webp';
import logo from './assets/logo.png';
// import axiosRestaurantInstance from './AxiosRestaurantInstance';


const Header = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));

    const handleSignOut = () => {
        localStorage.removeItem('user');
        navigate('https://jreats.com/');
    };

    // Function to open the support window
    const openSupportWindow = () => {
        const width = 600;
        const height = 400;
        const left = (window.innerWidth / 2) - (width / 2);
        const top = (window.innerHeight / 2) - (height / 2);
        const features = `width=${width},height=${height},top=${top},left=${left},resizable=yes`;

        const newWindow = window.open('/restaurant/support', '_blank', features); // Adjust URL as needed

        if (!newWindow) {
            alert('Please allow popups for this website');
        }
    };

    if (!user) {
        return <header className="header">No user data found</header>;
    }

    return (
        <header className="header">
            <div className="jr-eatslogo-section">
                <img src={logo} alt="Jr Eats Logo" className="jreats-logo"/>
                {/* <h1 className="header-title">Jr Eats</h1> */}

            </div>
            <div className="container1">
                <button className="btn-sprt" onClick={openSupportWindow}>
                    Support
                </button>
                <div className="user-info">
                    {/* Profile */}
                    <img src={profile} alt="Profile" className="profile-pic" />
                    <span className="user-details">{user.firstName}</span>

                    {/* Dropdown menu */}
                    <div className="dropdown">
                        <button className="dropdown-button" aria-label="User menu">
                            <FaCaretDown />
                        </button>
                        <div className="dropdown-content">
                            <Link to="/profile">Profile</Link>
                            <Link to="https://jreats.com/" onClick={handleSignOut}>Sign Out</Link>
                        </div>
                    </div>                    
                </div>
            </div>
        </header>
    );
};

export default Header;
